import * as colors from './Colors';
import { appTheme } from '../contexts/ThemeContext';

// Theme colors
export const primaryBackgroundColor = colors.whiteSmoke;
export const sectionsBackgroundColor = colors.white;
export const modalBackgroundColor = colors.white;
export const botTipsBackgroundColor = colors.white;

// eslint-disable-next-line import/no-mutable-exports
export let primaryTextColor = colors.darkslategray;
export const brandTextColor = colors.darkBlue;
export const linkPrimaryColor = colors.royalblue;

export const primaryBorderColor = colors.gainsboro;

// Fonts
export const primaryFontFamily = '"Source Sans Pro", Regular, sans-serif';
export const accentFontFamily = '"Bitter", Regular, sans-serif';

export const colorSchemeNames = {
    PAYCOR: 'paycor',
    TALENYA: 'talenya',
};

const themeInterval = setInterval(() => {
    if (appTheme) {
        primaryTextColor = appTheme?.common?.text?.color || colors.darkslategray;
        clearInterval(themeInterval);
    }
}, 1000);
